import { render, staticRenderFns } from "./ArticleInfoNormalTemplate.vue?vue&type=template&id=ac268e14&scoped=true"
import script from "./ArticleInfoNormalTemplate.vue?vue&type=script&lang=ts"
export * from "./ArticleInfoNormalTemplate.vue?vue&type=script&lang=ts"
import style0 from "./ArticleInfoNormalTemplate.vue?vue&type=style&index=0&id=ac268e14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac268e14",
  null
  
)

export default component.exports